<template>
<span v-bind:class="classNameContainer+' '+id">
  <span v-if="!dataid">{{ (emptydataid !== '<->') ? $t(emptydataid) : $t('FileUpload.emptydataid')}}</span>
  <template v-if="dataid">
    <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>
    <template v-if="textInBtn">
      <label for="fileUpload" v-bind:class="'btn btn-primary hiddenfilelabel '+className" style=""><i class="fa fa-file _-o _-text"></i> {{textInBtn}}</label>
      <input type="file" id="fileUpload" name="fileUpload" class="hiddenfileinput" :multiple="maxCount>1?multiple:''"/>
    </template>
    <template v-if="!textInBtn">
      <input type="file" id="fileUpload" name="fileUpload" v-bind:class="className" :multiple="maxCount>1?multiple:''"/>
    </template>
    <input type="hidden" id="id" name="dataid" :value="dataid"/>
    <input type="hidden" id="type" name="datatype" :value="datatype"/>
  </template>
  <!--<span v-on:click="fileUploadInputClick">ggg</span>-->
</span>
</template>

<script>
  //  import Vue from 'vue'
  //  import FileUpload from 'v-file-upload'
  //  Vue.use(FileUpload)
  import AlertInPage from '@/components/AlertInPage.vue';
  import Api from '@/api/Api';
  import {v4 as uuidv4} from 'uuid';

  export default {
    name: 'FileUpload',
    props: {
      'hasError': {
        type: [Boolean, String],
        default: ''
      },
      dataid: {
        type: String,
        default: ""
      },
      emptydataid: {
        type: String,
        default: "<->"
      },
      datatype: {
        type: String,
        default: ""
      },
//      required: {
//        type: Boolean,
//        default: false
//      },
      className: {
        type: String,
        default: "",
      },
      textInBtn: {
        type: String,
        default: "",
      },
      classNameContainer: {
        type: String,
        default: "",
      },
      disabled: {
        type: String,
        default: "false",
      },
      readonly: {
        type: String,
        default: "false",
      },
      url: {
        type: String,
        default: "default",
      },
      maxCount: {
        type: Number,
        default: 1,
      },
      handler: {
        type: Function,
        default: function () {
        },
      },

    },
    data () {
      return {

        id: "",
        xdataid: "",
        xdatatype: "",
        AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          delay: 5000,
        }


      }

    },
    mounted() {
      console.log("FileUpload");
      const modul = this;
      modul.id = 'fileUpload' + uuidv4();
      this.init();

//      modul.$eventBus.$on('globalImagesRefresh', this.globalImagesRefreshEventHandler);
    },
    beforeDestroy() {
//      this.$eventBus.$off('globalImagesRefresh');
    },
    watch: {
      "$store.state.healthCheckHash": function (newData, oldData) {
        const modul = this;
        if (newData !== oldData) {
          modul.state = Object.assign({}, modul.$store.state);
        }
      },
      "dataid": function (newData, oldData) {
        const modul = this;
        if (newData !== oldData) {
          if (newData) {
            setTimeout(function () {
              const element = document.querySelector('.' + modul.id + ' #fileUpload')
              if (element !== null) {
                element.addEventListener('change', event => {
                  modul.handleImageUpload(event)
                })

              }

            }, 0)
          } else {
            const element = document.querySelector('.' + modul.id + ' #fileUpload')
            if (element !== null) {
              element.removeEventListener('change', modul.handleImageUpload)
            }
          }

        }

      },
    },
    methods: {
      init() {
        const modul = this;
        modul.state = Object.assign({}, modul.$store.state);
        console.log("FileUploader init")
//        document.querySelector('#fileUpload').addEventListener('change', event => {
//          modul.handleImageUpload(event)
//        })


        if (modul.dataid) {
          setTimeout(function () {
            const element = document.querySelector('.' + modul.id + ' #fileUpload')
            if (element !== null) {
              element.addEventListener('change', event => {
                if (element !== null) {
                  modul.handleImageUpload(event)
                }
              })
            }
          }, 0)
        } else {
          const element = document.querySelector('.' + modul.id + ' #fileUpload')
          if (element !== null) {

            element.removeEventListener('change', modul.handleImageUpload)
          }
        }


      },
      handleImageUpload (event) {
        const modul = this;
        const formData = new FormData()
        const files = event.target.files
        // TODO
        // Files maximalize
        // file size maximalize


        const maxCount = modul.maxCount;
        const maxFileSize = 15000000;
        let actCount = 0;
        console.log("files")
        let filesize_error = false;
        if (maxCount > 1) {
          Array.prototype.forEach.call(files, function (file) {
            actCount++;
            if (actCount <= maxCount) {
              if (file.size <= maxFileSize) {
                formData.append('files', file)
              } else {
                modul.AlertInPage.msg = "form.filesize_error";
                modul.AlertInPage.type = "danger";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
                }, Number(modul.AlertInPage.delay));
                document.querySelector('#fileUpload').value = "";
                filesize_error = true;
              }
            }
          });
        } else {
          if (files[0].size <= maxFileSize) {
            formData.append('file', files[0])
          } else {
            modul.AlertInPage.msg = "form.filesize_error";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));
            document.querySelector('#fileUpload').value = "";
            filesize_error = true;
          }
        }
        if (filesize_error) {
          return;

        }
        let urlVar = modul.url;
        if (modul.url === "default") {
          if (maxCount > 1) {
            urlVar = "uploadFiles";
          } else {
            urlVar = "uploadFile";
          }
        }
        formData.append('id', modul.dataid)
        formData.append('data', modul.datatype)
        formData.append('id_company', modul.state.id_company)
        const url = Api.baseUrl + Api.apiUrl + urlVar;
        const apiHeader = Api.getHeader()
        const authorization = apiHeader.Authorization;
        const header = {};
        header['Accept'] = "*/*";
        header['Authorization'] = authorization;
        fetch(url, {
          method: 'POST',
          body: formData,
          headers: header
        })
          .then(response => response.json())
          .then(data => {
            modul.handler(data, void 0);
            document.querySelector('#fileUpload').value = "";

            modul.AlertInPage.msg = "form.save_succes";
            modul.AlertInPage.type = "success";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));
            modul.$eventBus.$emit('globalImagesRefresh', {refresh: true, type: modul.datatype});
          })
          .catch(error => {
            modul.handler(void 0, error);
            document.querySelector('#fileUpload').value = "";

            modul.AlertInPage.msg = "form.save_error";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));

          })
      },
      fileUploadInputClick() {
        const modul = this;
        console.log("fileUploadInputClick")
//        setTimeout(function () {
////          document.querySelector('.'+modul.id+' #fileUpload').click()
//        },2000)
        document.querySelector('.' + modul.id + ' #fileUpload').click()
      },

    },
    components: {
      AlertInPage,
    }

  }
</script>

<style scoped="">
  .hiddenfileinput {
    visibility: hidden;
    height: 1px;
    width: 1px;
    display: block;
  }

  .hiddenfilelabel {
    margin: 0;
  }
</style>
